"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fakeEthAddress = exports.fakeTxHash = exports.fakeHexString = void 0;
const ethers_1 = require("ethers");
const HEX_DIGITS_CASE_SENSITIVE = '00112233445566778899AaBbCcDdEeFf';
function fakeHexDigit() {
    return HEX_DIGITS_CASE_SENSITIVE[Math.floor(Math.random() * HEX_DIGITS_CASE_SENSITIVE.length)];
}
function fakeHexString(digits) {
    const generated = new Array(digits).fill(0).map(fakeHexDigit).join('');
    return `0x${generated}`;
}
exports.fakeHexString = fakeHexString;
function fakeTxHash() {
    return fakeHexString(64);
}
exports.fakeTxHash = fakeTxHash;
function fakeEthAddress() {
    return ethers_1.Wallet.createRandom().address;
}
exports.fakeEthAddress = fakeEthAddress;
//# sourceMappingURL=fakeHex.js.map